import { UserType } from '~/utils/enum'

const User = [
  {
    path: '',
    redirect: '/user'
  },
  {
    name: 'User',
    path: '/user/:id',
    component: () => import('pages/user/user.vue'),
    meta: {
      title: '个人主页'
    }
  },
  {
    name: 'Author',
    path: '/author',
    component: () => import('pages/user/author.vue'),
    meta: {
      title: '开发者主页',
      rols: [UserType.Developer, UserType.Admin, UserType.StationMaster]
    }
  },
  {
    name: 'Login',
    path: '/login',
    component: () => import('pages/user/login.vue'),
    meta: {
      title: '登录'
    }
  },
  {
    name: 'UpdateUser',
    path: '/updateUser',
    component: () => import('pages/user/updateUser.vue'),
    meta: {
      title: '修改资料',
      rols: [UserType.Normal, UserType.Developer, UserType.Admin, UserType.StationMaster]
    }
  },
  {
    name: 'UpdatePassword',
    path: '/updatePassword',
    component: () => import('pages/user/updatePassword.vue'),
    meta: {
      title: '修改密码'
    }
  },
  {
    name: 'ForgetPassword',
    path: '/forgetPassword',
    component: () => import('pages/user/forgetPassword.vue'),
    meta: {
      title: '忘记密码'
    }
  }
]
export default User
